import { makeAutoObservable } from 'mobx'
import RootStore  from 'mobx-stores/root-store'
import { StoreDTO } from 'models'
import { Api } from 'services'

export class StoresMainStore {
  private storeApi: Api['storeApi']
  private rootStore:any

  constructor (rootStore:any) {
    this.storeApi = rootStore.generalStore.api.storeApi
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  // OBSERVABLES
  private stores: Map<number, StoreDTO> = new Map()

  // ACTIONS
  private setStore = (store: StoreDTO): void => {
    this.stores.set(store.id, store)
  }

  public getStoreById = async (storeId: number | string): Promise<StoreDTO> => {
    let storeIdAsNumber = null
    try {
      storeIdAsNumber = Number(storeId)
      if (isNaN(storeIdAsNumber)) {
        const errorMessage = `Not a valid number ${storeIdAsNumber}`
        storeIdAsNumber = null
        throw new Error(errorMessage)
      }
    } catch (error) {
      console.error(error)
      this.rootStore.generalStore.showError(
        `Store ID ${storeId} is not a valid number`
      )
    }
    if (!storeIdAsNumber) return

    const store = await this.storeApi.getStoreById(storeId)
    if (!store) return
    this.setStore(store)

    const loadedStore = this.stores.get(storeIdAsNumber)
    if (loadedStore) return loadedStore

    if (store.id === this.rootStore.userStore.assignedStoreId) {
      this.rootStore.userStore.updateAssignedStore()
    }

    return store
  }
}
